<template>
  <v-alert
    class="survey-allert"
    dense
    outlined
    color="secondary"
    type="warning"
  >
    <template #prepend>
      <v-icon>{{ icon }}</v-icon>
    </template>
    <div class="survey-allert__text">{{ content }}</div>
  </v-alert>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: false,
      default: 'mdi-information-variant',
    },
    content: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.survey-allert {
  background: $color--bg !important;
  padding: 24px 24px 24px 16px !important;
  margin-bottom: 24px;

  &__text {
    padding-left: 16px;
    font-size: 14px;
  }

  .v-alert__wrapper {
    align-items: start;
  }

  .v-icon {
    background: #E2E6EA;
    border-radius: 50%;
    padding: 4px;
    margin-top: 6px;
    color: white;
  }
}
</style>
